export class CRRALinkModel {
    linkId: number;
    stateId: number;
    linkTypeId: number;
    citation: string;
    description: string;
    url: string;
}
export class CRRAGetLinkModel {
    linkId: number;
    stateId: number;
    linkTypeId: number;
    citation: string;
    description: string;
    url: string;
    linkTypeName: string;
    stateName: string;
    totalRecordCount: number;
}
export class CRRALinkTypeModel {
    linkTypeId: number;
    linkTypeName: string;
}


export class FilterGetLink {
    linkTypeId: string;
    stateId: string;
    pageNumber: number;
    pageSize: number;
    orderBy: string;
    IsExport?:boolean;
}
